import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import ScrollOut from "scroll-out";

const Esg = () => {
    useEffect(() => {
        ScrollOut({
            threshold: 0.3,
            once: true
        });
    }, []);

    return (
        <>
            <SubHead title="ESG경영" eng="MAMAGEMENT"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <p class="tit-guide-sbj esg-sbj" data-scroll>
                        <em>ESG경영</em>으로 <b>지속가능한 성장</b>을 실현하겠습니다.
                    </p>
                    <p className="tit-guide-sm" data-scroll>
                        기업의 이윤추구뿐만이 아니라, 사회에 미칠 장기적인 영향까지 고심하겠습니다. <br />
                        ktMOS북부는 Compliance TF 구성을 통해 공정한 준법경영을 실행하고 무엇보다 안전한 일터를 만들기 위해 지속적으로 위험요소를 관리하고 있습니다. <br />
                        더욱이 2022년 6월, <b>RE100*</b> 가입하고 다양한 환경캠페인을 통해 탄소절감 활동 및 친환경 실천에 앞서나가고 있습니다. <br />
                        기업의 지속가능성과 더불어 사회, 환경의 미래를 위해 고민하고 사회적 책임을 다 하겠습니다. <br />
                        <b>*RE100</b> : 기업이 사용하는 전력 100%를 재생에너지로 충당하겠다는 캠페인
                    </p>

                    <div className="esg-infos-wrap gray-back-bg">
                        <ul className="esg-infos-ul" data-scroll>
                            <li>
                                <p className="title">
                                    <span>E</span>
                                    Environment
                                </p>
                                <div className="icon_box n01"></div>
                                <p className="sbj">
                                    친환경 경영 체계 구축으로 <br />
                                    <b>더 나은 미래 가치 창출</b>
                                </p>
                                <dl>
                                    <dt>물리적 전환을 통한 탄소배출량 감축</dt>
                                    <dd>ㆍ전기/수소차 전환, 노후장비 교체</dd>
                                </dl>
                                <dl>
                                    <dt>다양한 캠페인을 통한 환경 보호</dt>
                                    <dd>
                                        ㆍ일회용 플라스틱 줄이기, 디지털 쓰레기 줄이기 <br />
                                        (사용하지 않는 메일함 삭제하기)
                                    </dd>
                                </dl>
                            </li>
                            <li>
                                <p className="title">
                                    <span>S</span>
                                    Social
                                </p>
                                <div className="icon_box n02"></div>
                                <p className="sbj">
                                    기본보다 더 철저한 안전관리로 <br />
                                    <b>안전하고 건강한 일터 구현</b>
                                </p>
                                <dl>
                                    <dt>안전 최우선 경영</dt>
                                    <dd>ㆍSafety Leadership 강화, ISO 45001 국제 표준 인증, 안전보건 관리체계 구축 및 이행</dd>
                                </dl>
                                <dl>
                                    <dt>현장 안전 확보</dt>
                                    <dd>ㆍ위험성 평가 및 개선, 안전강화 솔루션 적용</dd>
                                </dl>
                                <dl>
                                    <dt>동반 성장</dt>
                                    <dd>ㆍ안전보건 교육&점검 후 개선방안 공유, 안전 우선 인식문화 확산 및 평가 우대</dd>
                                </dl>
                            </li>
                            <li>
                                <p className="title">
                                    <span>G</span>
                                    Governance
                                </p>
                                <div className="icon_box n03"></div>
                                <p className="sbj">
                                    공정하고 투명한 경영을 통한 <br />
                                    <b>윤리기업 실현</b>
                                </p>
                                <dl>
                                    <dt>윤리경영</dt>
                                    <dd>ㆍ신뢰받는 기업풍토 조성과 공정한 조직문화 조성</dd>
                                </dl>
                                <dl>
                                    <dt>준법경영</dt>
                                    <dd>ㆍCompliance TF 구성으로 전문적이고 공정한 준법경영 실행, Compliance 활동 시스템화 및 준법문화 정착</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Esg;
